module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('div', {
    attrs: {
      "id": "logo-top"
    }
  }), _vm._v(" "), _c('nav', {
    attrs: {
      "id": "nav"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#one"
    }
  }, [_vm._v("Sobre")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#three"
    }
  }, [_vm._v("Fale Conosco")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "button special",
    attrs: {
      "href": "dashboard.html"
    }
  }, [_vm._v("Área do Logista")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58d34788"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 1251
// module chunks = 1